import React, { useMemo, useState } from 'react';

import {
  Box,
  Paper,
  TableContainer,
  TablePagination
} from '@mui/material';

import EditableTable from './EditableTable';
import { paginationSx } from '../../../../Common/components/Listing/styles';

const medicines = [
  { id: 1, name: 'Wellbutrin', reaction: '---' },
  { id: 2, name: 'Xanax', reaction: '---' },
  { id: 3, name: 'Lithium', reaction: '' },
  { id: 4, name: 'Viox', reaction: '' },
  { id: 5, name: 'Zithromax', reaction: '' },
  { id: 6, name: 'Tramadol', reaction: '' },
  { id: 7, name: 'Nexium', reaction: '' },
  { id: 8, name: 'Microbid', reaction: '' },
  { id: 9, name: 'Ceftin', reaction: '' },
  { id: 10, name: 'Amoxicillin', reaction: '' },
  { id: 11, name: 'Wellbutrin', reaction: '' },
  { id: 12, name: 'Xanax', reaction: '' },
  { id: 13, name: 'Lithium', reaction: '' },
  { id: 14, name: 'Viox', reaction: '' },
  { id: 15, name: 'Zithromax', reaction: '' },
  { id: 16, name: 'Tramadol', reaction: '' }
];

const columns = [
  {
    field: 'name',
    label: 'Name',
    placeholder: 'Input Name',
    width: '35%'
  },
  {
    field: 'reaction',
    label: 'Reaction',
    placeholder: 'Input Reaction',
    width: '55%'
  }
];

const MyTemplates = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showAddRow, setShowAddRow] = useState(true);

  const visibleRows = useMemo(() => {
    const start = page * rowsPerPage;

    return medicines.slice(start, start + rowsPerPage);
  }, [page, rowsPerPage]);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Paper
        variant="outlined"
        sx={{
          height: 525,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderColor: '#D9D9D9',
          borderRadius: '10px',
          boxShadow: 'none'
        }}>
        <TableContainer
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'auto',

            '&::-webkit-scrollbar': {
              display: 'none'
            },

            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}>
          <EditableTable
            columns={columns}
            rows={visibleRows}
            showAddRow={showAddRow}
            onCancelAdd={() => setShowAddRow(false)}
          />
        </TableContainer>

        <TablePagination
          component="div"
          count={medicines.length}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 15, 25]}
          labelRowsPerPage="Rows per page:"
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          sx={{
            ...paginationSx,
            flexShrink: 0,
            width: '100%',
            boxSizing: 'border-box',
            bgcolor: '#F7F7F7',
            borderTop: '1px solid #E0E0E0'
          }}
        />
      </Paper>
    </Box>
  );
};

export default MyTemplates;